import {
  Box,
  Button,
  Image,
  SimpleGrid,
  Text,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import QRCode from "react-qr-code";
import { Link, useLocation } from "react-router-dom";
import QRIS from "../assets/payment/qris.png";
import Shape1 from "../assets/qris/shape1.png";
import Shape2 from "../assets/qris/shape2.png";

export default function ScanQris() {
  const location = useLocation();
  const toast = useToast();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const url = "/orders/verify/qris";

  if (location.state === null) {
    window.location.replace("/keranjang");
  }
  const [data, setData] = useState(location.state);
  console.log(data);

  const expiredDate = new Date();

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  const handleCheckPayment = () => {
    axios
      .post(
        baseURL + url,
        {
          order_id: data.order_id,
          qr_value: data.payment_metadata.qr_value,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((res) => {
        const status = res.data.data.order_status;
        console.log(status);
        if (res.status === 200) {
          toast({
            title: "Status Pembayaran",
            description:
              status === "UNPAID"
                ? "Masih Belum Dibayarkan"
                : "Berhasil Dibayarkan",
            duration: 10000,
            status: status === "UNPAID" ? "warning" : "success",
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  return (
    <Box display="flex" alignItems="center" flexDir="column" p="10">
      <Box py="2">
        <img src="/assets/payment/qris.png" alt="qris" width="150px" />
      </Box>
      <Text fontSize="20" color="#131313">
        Scan QRIS untuk membayar
      </Text>
      <Text pt="2">Total yang harus dibayar</Text>
      <Text fontWeight="700" pb="2">
        {IDRConvert.format(data.grand_total)}
      </Text>
      <Box display="inline-block" m="5">
        <Box display="flex" pt="3">
          <Image src={QRIS} alt="shape1" w="full" />
        </Box>
        <Box px="10" pt="20" pb="10" pos="relative">
          <Text
            pos="absolute"
            top="5"
            left="0"
            right="0"
            textAlign="center"
            fontWeight="700"
            color="gray"
            pb="2"
          >
            {data.payment_metadata.merchant_name}
            <Text fontWeight="400">NMID : {data.payment_metadata.nmid}</Text>
          </Text>
          <Image
            pos="absolute"
            top="0px"
            left="0px"
            src={Shape1}
            alt="shape1"
          />
          <Image
            pos="absolute"
            bottom="0px"
            right="0px"
            src={Shape2}
            alt="shape2"
          />
          <Text
            pos="absolute"
            bottom="0"
            textAlign="center"
            color="gray"
            fontSize="13"
            pb="2"
          >
            Dicetak Oleh: {data.payment_metadata.nns}
          </Text>
          <QRCode
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={data.payment_metadata.qr_value}
          />
        </Box>
      </Box>
      <Text fontWeight="700" pb="2">
        {IDRConvert.format(data.grand_total)}
      </Text>
      <Text fontWeight="700" pb="2">
        {data.payment_metadata.bill_number}
      </Text>
      <Text fontWeight="700" pb="2">
        Expired: {data.payment_metadata.expiry_date}
      </Text>
      <SimpleGrid columns={[1, 2]} spacing={2} py="4">
        <Button variant="outline" onClick={handleCheckPayment}>
          Cek Status Pembayaran
        </Button>
        <Link to="/">
          <Button w="full" colorScheme="blue">
            Belanja Lagi
          </Button>
        </Link>
      </SimpleGrid>
    </Box>
  );
}
